(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newbalance-media-collezione"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('media-collection-dawn')) {
    customElements.define('media-collection-dawn', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        this.track = this.querySelector('.mc-dawn__track');
        this.controls = this.querySelector('.mc-dawn__controls');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const video = this.querySelector('video');
        if (video && this.querySelector('[data-autoplay="true"]') && !reducedMotion.matches) {
          video.muted = true;
          video.play().catch(() => {});
        }
        if (!this.track) return;
        this.buttons = [...this.querySelectorAll('[data-direction]')];
        const update = () => {
          const trackRect = this.track.getBoundingClientRect();
          const slides = [...this.track.children];
          const first = slides[0].getBoundingClientRect();
          const last = slides[slides.length - 1].getBoundingClientRect();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          this.controls.hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
          this.buttons[0].disabled = rtl ? first.right <= trackRect.right + 6 : first.left >= trackRect.left - 6;
          this.buttons[1].disabled = rtl ? last.left >= trackRect.left - 6 : last.right <= trackRect.right + 6;
        };
        const move = (direction) => {
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          const step = this.track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
          this.track.scrollBy({ left: direction * step * (rtl ? -1 : 1), behavior: reducedMotion.matches ? 'instant' : 'smooth' });
        };
        this.buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), { signal }));
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }, { signal });
        this.track.addEventListener('scroll', update, { passive: true, signal });
        this.resizeObserver = new ResizeObserver(update);
        this.resizeObserver.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        this.querySelector('video')?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gigi-specchio"] && !Shopify.designMode) return;
  try {
    
  function updateGigiVideoWidth() {
    document.documentElement.style.setProperty('--video-gigi-specchio-viewport-width', `${document.documentElement.clientWidth}px`);
  }
  updateGigiVideoWidth();
  window.addEventListener('resize', updateGigiVideoWidth);

  if (!customElements.get('gigi-specchio-video')) {
    customElements.define('gigi-specchio-video', class extends HTMLElement {
      connectedCallback() {
        this.mediaQuery = window.matchMedia('(max-width: 749px)');
        this.onMediaChange = () => {
        this.showVideo();
        this.scheduleButtonsLayout();
      };
        this.mediaQuery.addEventListener('change', this.onMediaChange);
        this.showVideo();
        this.buttonsContainer = this.querySelector('.video-gigi-specchio__buttons');
      this.buttons = Array.from(this.querySelectorAll('.video-gigi-specchio__button'));
      this.layoutSignature = '';
      const content = this.querySelector('.video-gigi-specchio__content');
        if (content) {
          this.contentObserver = new ResizeObserver(() => {
            this.style.setProperty('--gigi-content-half-height', `${content.offsetHeight / 2}px`);
          this.scheduleButtonsLayout();
          });
          this.contentObserver.observe(content);
        }
      }
      disconnectedCallback() {
        this.mediaQuery?.removeEventListener('change', this.onMediaChange);
        this.contentObserver?.disconnect();
      cancelAnimationFrame(this.layoutFrame);
        this.querySelector('video')?.pause();
      }
      scheduleButtonsLayout() {
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => {
        if (this.isConnected) this.layoutButtons();
      });
    }
    layoutButtons() {
      const container = this.buttonsContainer;
      if (!container || !this.buttons.length) return;
      const mode = this.mediaQuery.matches ? this.dataset.layoutMobile : this.dataset.layoutDesktop;
      if (mode !== 'spread') {
        if (container.hasAttribute('data-spread-ready')) {
          const focused = document.activeElement;
          container.replaceChildren(...this.buttons);
          if (this.buttons.includes(focused)) focused.focus({ preventScroll: true });
          container.removeAttribute('data-spread-ready');
          container.style.removeProperty('--gigi-measured-button-size');
        }
        this.layoutSignature = '';
        return;
      }
      const content = this.querySelector('.video-gigi-specchio__content');
      const available = content.clientWidth;
      if (available <= 0) return;
      const styles = getComputedStyle(container);
      const read = (name, fallback) => {
        const value = parseFloat(styles.getPropertyValue(name));
        return Number.isFinite(value) ? value : fallback;
      };
      const spread = Math.min(100, Math.max(0, read('--gigi-spread', 0))) / 100;
      const size = Math.min(available, Math.max(44, read('--gigi-button-size', 160)));
      const minimumGap = Math.max(0, read('--gigi-gap', 12));
      const requestedColumns = Math.max(1, Math.floor(read('--gigi-columns', 3)));
      const fittingColumns = Math.max(1, Math.floor((available + minimumGap) / (size + minimumGap)));
      const columns = Math.min(requestedColumns, fittingColumns, this.buttons.length);
      const signature = [available, spread, size, minimumGap, columns, this.buttons.length].join(':');
      if (signature === this.layoutSignature) return;
      this.layoutSignature = signature;
      container.setAttribute('data-spread-ready', '');
      container.style.setProperty('--gigi-measured-button-size', `${size}px`);
      if (this.rowColumns !== columns || !container.querySelector('.video-gigi-specchio__button-row')) {
        const focused = document.activeElement;
        const rows = document.createDocumentFragment();
        for (let index = 0; index < this.buttons.length; index += columns) {
          const row = document.createElement('div');
          row.className = 'video-gigi-specchio__button-row';
          row.append(...this.buttons.slice(index, index + columns));
          rows.append(row);
        }
        container.replaceChildren(rows);
        this.rowColumns = columns;
        if (this.buttons.includes(focused)) focused.focus({ preventScroll: true });
      }
      for (const row of container.children) {
        const count = row.children.length;
        const maximumGap = count > 1 ? Math.max(0, (available - count * size) / (count - 1)) : 0;
        const baseGap = Math.min(minimumGap, maximumGap);
        const gap = baseGap + (maximumGap - baseGap) * spread;
        row.style.setProperty('--gigi-distributed-gap', `${gap}px`);
      }
    }
    showVideo() {
        const variant = this.mediaQuery.matches ? 'mobile' : 'desktop';
        const template = this.querySelector(`template[data-variant="${variant}"]`);
        const media = this.querySelector('.video-gigi-specchio__media');
        if (!template || !media) return;
        const previous = media.querySelector('video');
        if (previous) {
          previous.pause();
          previous.removeAttribute('src');
          previous.querySelectorAll('source').forEach(source => source.remove());
          previous.load();
        }
        media.replaceChildren(template.content.cloneNode(true));
        const video = media.querySelector('video');
        if (video) {
          video.muted = true;
          video.play().catch(() => {});
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
